import notificationsActionTypes from '../actionTypes/notificationsActionTypes';
import {
  getNotificationsApi,
  readAllNotificationsApi,
  readNotificationApi,
  getUnreadNotificationsApi,
} from '../../api/apiUrls/notifications';

const getNotificationsStart = () => ({
  type: notificationsActionTypes.GET_NOTIFICATIONS_START,
});
const getNotificationsSuccess = (payload) => ({
  type: notificationsActionTypes.GET_NOTIFICATIONS_SUCCESS,
  payload,
});
const getNotificationsFail = () => ({
  type: notificationsActionTypes.GET_NOTIFICATIONS_FAILURE,
});

const getNotifications = (token, params) => (dispatch) => {
  dispatch(getNotificationsStart());

  return getNotificationsApi(token, params)
    .then((response) => {
      if (response.data.success) {
        dispatch(getNotificationsSuccess(response.data));
      }
    })
    .catch(() => {
      dispatch(getNotificationsFail());
    });
};

const readNotificationStart = () => ({
  type: notificationsActionTypes.READ_NOTIFICATION_START,
});

const readNotificationSuccess = (payload) => ({
  type: notificationsActionTypes.READ_NOTIFICATION_SUCCESS,
  payload,
});

const readNotificationFail = () => ({
  type: notificationsActionTypes.READ_NOTIFICATION_FAILURE,
});

const readNotification = (token, id) => (dispatch) => {
  dispatch(readNotificationStart());

  return readNotificationApi(token, id)
    .then((response) => {
      dispatch(readNotificationSuccess(id));

      return response;
    })
    .catch(() => {
      dispatch(readNotificationFail());
    });
};

const readAllNotificationsStart = () => ({
  type: notificationsActionTypes.READ_ALL_NOTIFICATIONS_START,
});

const readAllNotificationsSuccess = () => ({
  type: notificationsActionTypes.READ_ALL_NOTIFICATIONS_SUCCESS,
});

const readAllNotificationsFail = () => ({
  type: notificationsActionTypes.READ_ALL_NOTIFICATIONS_FAILURE,
});

const readAllNotifications = (token) => (dispatch) => {
  dispatch(readAllNotificationsStart());

  return readAllNotificationsApi(token)
    .then((response) => {
      dispatch(readAllNotificationsSuccess());

      return response;
    })
    .catch(() => {
      dispatch(readAllNotificationsFail());
    });
};

const getUnreadNotificationsStart = () => ({
  type: notificationsActionTypes.GET_UNREAD_NOTIFICATIONS_START,
});
const getUnreadNotificationsSuccess = (payload) => ({
  type: notificationsActionTypes.GET_UNREAD_NOTIFICATIONS_SUCCESS,
  payload,
});
const getUnreadNotificationsFail = () => ({
  type: notificationsActionTypes.GET_UNREAD_NOTIFICATIONS_FAILURE,
});

const getUnreadNotifications = (token, params) => (dispatch) => {
  dispatch(getUnreadNotificationsStart());

  return getUnreadNotificationsApi(token, params)
    .then((response) => {
      if (response.data.success) {
        dispatch(getUnreadNotificationsSuccess(response.data));
      }
    })
    .catch(() => {
      dispatch(getUnreadNotificationsFail());
    });
};

const addUnreadNotifications = (notifications) => ({
  type: notificationsActionTypes.ADD_UNREAD_NOTIFICATIONS,
  payload: notifications,
});

const notificationsActions = {
  getNotifications,
  readNotification,
  readAllNotifications,
  getUnreadNotifications,
  addUnreadNotifications,
};

export default notificationsActions;
